import { useEffect } from "react";
import { useNotificationsStreamContext } from "./useNotificationStreamContext";
export const useListenNotificationStream = (callback) => {
    const eventSource = useNotificationsStreamContext();
    useEffect(() => {
        if (eventSource == null) {
            return;
        }
        const listener = (event) => {
            const newNotification = JSON.parse(event.data);
            callback(newNotification);
        };
        eventSource.addEventListener("notification_received", listener);
        // eslint-disable-next-line consistent-return
        return () => {
            eventSource.removeEventListener("notification_received", listener);
        };
    });
};
//# sourceMappingURL=useListenNotificationStream.js.map